import css from "../../css/common/breadcrumbs.module.css";

import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { useHistory } from "../common/History";

import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";

const Breadcrumbs = (props) => {
    const { location } = props;

    const history = useHistory();
    const referrer = history.getPrevious();

    let zip = null;
    let city = null;
    let state = null;

    if (location) {
        switch (location.type) {
            case "city":
                city = location.location;
                state = city.state;
                break;
            case "state":
                state = location.location;
                break;
            case "zip":
                zip = location.location;

                city = zip.cities.find((c) => {
                    return c.is_primary === "1";
                });

                if (city) {
                    state = city.state;
                } else {
                    if (zip.cities.length > 0) {
                        city = zip.cities[0];
                        state = city.state;
                    }
                }
                break;
            default:
                zip = null;
                city = null;
                state = null;
        }
    }

    return (
        <div className={css.breadcrumbsShadow}>
            <div className={css.wrapper}>
                <div className={css.back}>
                    {referrer && (
                        <Link
                            href={{
                                pathname: referrer.pathname,
                                query: referrer.query,
                            }}
                            as={referrer.asPath}
                            passHref={true}
                            onClick={() => history.pop()}
                        >
                            <ChevronLeftIcon />
                            Go back
                        </Link>
                    )}
                </div>

                {location && (
                    <div className={css.path}>
                        Find an Agent
                        {city && (
                            <>
                                <ChevronRightIcon />
                                <Link
                                    href={`/agents?location=${city.url}`}
                                    as={`/real_estate_agents/${city.url}`}
                                    passHref={true}
                                >
                                    {city.name}
                                </Link>
                            </>
                        )}
                        {state && (
                            <>
                                <ChevronRightIcon />
                                <Link
                                    href={`/agents?location=${state.url}`}
                                    as={`/real_estate_agents/${state.url}`}
                                    passHref={true}
                                >
                                    {state.abbr}
                                </Link>
                            </>
                        )}
                        {zip && (
                            <>
                                <ChevronRightIcon />
                                <Link
                                    href={`/agents?location=${zip.url}`}
                                    as={`/real_estate_agents/${zip.url}`}
                                    passHref={true}
                                >
                                    {zip.code}
                                </Link>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

Breadcrumbs.propTypes = {
    location: PropTypes.object,
};

Breadcrumbs.defaultProps = {
    location: null,
};

export default Breadcrumbs;
